import React, { Component, useState, useEffect } from "react";
import AuthHeader from "./AuthHeader";
import { Input, Button } from "antd";

function ForgotPassword(props) {
  const [email, setEmail] = useState(null);
  const [disableSendButton, setDisableSendButton] = useState(false);
  const SendPasswordResetEmail = async () => {
    if (email.length === 0 || email.search(/[a-zA-Z0-9_.\-+[\]"']+@[a-zA-Z0-9_.\-+[\]"']+[.][a-zA-Z0-9_.\-+[\]"']+/) === -1) return props.MakeNotification("warning", "Please enter a valid email.");
    setDisableSendButton(true);
    let response = await props.AxiosRequest("/api/user/initiate-password-reset", { email });
  };
  return (
    <div>
      <AuthHeader />
      <main className="main h-100 w-100">
        <div className="container h-100">
          <div className="row h-100">
            <div className="col-sm-10 col-md-8 col-lg-6 mx-auto d-table h-100">
              <div className="d-table-cell align-middle"></div>
              <div className="text-center mt-4">
                <h1 className="h2">Forgot your password?</h1>
                <p className="lead">Don't fret!</p>
              </div>
              <div className="card" id="success-card">
                <div className="card-body text-center">
                  <div className="m-sm-4">
                    <div className="mb-3">
                      Input the email you would log into FirmTamer with and we will send you instructions on how to reset your password.
                      <br></br>
                      <br></br>
                      <Input className="form-control form-control-lg" type="email" name="email" placeholder="Enter your email" value={email} onChange={(e) => setEmail(e.target.value)} />
                      <div className="text-center mt-3">
                        <Button type="primary" onClick={() => SendPasswordResetEmail()} disabled={disableSendButton}>
                          Reset Password
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

export default ForgotPassword;
